import React from 'react';
import { Row, Col} from 'reactstrap';

const Loading = () => (
  <Row>
    <Col md={{ size: 10,offset: 1 }} className="formGroup TextCenter">
      <h2>
        Bezig met laden...
      </h2>

    </Col>
  </Row>
);

export default Loading



// WEBPACK FOOTER //
// ./src/app/Loading.jsx